var n = Object.getOwnPropertySymbols;
var l = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
var i = (o, r) => {
  var t = {};
  for (var e in o)
    l.call(o, e) && r.indexOf(e) < 0 && (t[e] = o[e]);
  if (o != null && n)
    for (var e of n(o))
      r.indexOf(e) < 0 && a.call(o, e) && (t[e] = o[e]);
  return t;
};
import { jsx as s } from "react/jsx-runtime";
import { Badge as u } from "../../../DataDisplay/Badge/Badge.es.js";
function p(t) {
  var e = t, {
    children: o
  } = e, r = i(e, [
    "children"
  ]);
  return /* @__PURE__ */ s(u, { text: o, variant: "contained", color: "bgWeak", closable: !0, rounded: !0, size: "sm", style: {
    zIndex: 4
  }, onClose: r.removeProps.onClick });
}
export {
  p as MultiValue
};
//# sourceMappingURL=MultiValue.es.js.map
